import styled, { keyframes } from 'styled-components'

import { Menu, TypeStyle } from '@syconium/little-miss-figgy'

export const fadeDownAndIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

export const Body = styled.div`
  display: flex;
  padding: 10px 0;
`

export const Menubar = styled(Menu.Menubar)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${o => o.theme.spacing(5)};
  row-gap: ${o => o.theme.spacing(2.5)};
  z-index: 4;
`

export const Label = styled(TypeStyle.HeadlineMicro)`
  color: ${o => o.theme.color.deprecated.obsidianLighter};
  margin-inline-start: auto;
  padding: 10px 0;
  white-space: nowrap;
`
